import React, { Component } from 'react';
import './../../css/Header.css';
import logo from './../../images/logo.png';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: ""
        };

        this.onRouteChanged = this.onRouteChanged.bind(this);
    };

    componentWillMount() {
        window.addEventListener("onRouteChanged", this.onRouteChanged);
    };

    componentWillUnmount() {
        window.removeEventListener("onRouteChanged",this.onRouteChanged);
    };

    onRouteChanged(event) {
        let route = event.detail.route || event.detail.parentRoute || null;
        if(route) {
            this.setState({title: route.title});
        }
    };

    render() {
        return (
            <header role="banner">
            <div className="header-wrapper discover-pay animation">
            <a id="skip-content" href="#main-content-rwd" class="sr-only sr-only-focusable preventDefaultBehaviour">Skip to main content</a>
                <div className="header-content">
                    
                        <div href="#" className="discover-logo">

                        <img src={logo} width="120" height="25" alt="discover logo" />
                        </div>

                    
                </div>

            </div>
        </header>
        );
    }
}

export default Header;
